import { render, staticRenderFns } from "./IframeModal.vue?vue&type=template&id=0fc0ac63"
import script from "./IframeModal.vue?vue&type=script&lang=js"
export * from "./IframeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports